import { Observable } from "rxjs/Observable";
import { IAPIResponse, WeGoConfig, DataListModel } from "../../shared/config";
import { RequestOptions, Http, Headers } from "@angular/http";
import { Injectable } from "@angular/core";
import { AuthService } from "../../shared/models/auth.service";
import { CustomerModel } from "./customer.model";

@Injectable()
export class CustomerService {
  constructor(private authService: AuthService, private http: Http) {}

  public GetCustomerList(input?: DataListModel): Observable<IAPIResponse> {
    let getCustomerListUrl = WeGoConfig.API_GET_CUSTOMER_LIST;
    let queryString = this.authService.HandleAPIListInput(input);
    if (queryString) {
      getCustomerListUrl = getCustomerListUrl + "?" + queryString;
    }
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCustomerListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCustomerByHashId(customerHashId: string): Observable<IAPIResponse> {
    let getSignupConfigUrl =
      WeGoConfig.API_GET_CUSTOMER_BY_HASH + "?customerHashID=" + customerHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getSignupConfigUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetCustomerBasicDetail(
    customerHashId: string
  ): Observable<IAPIResponse> {
    let getUrl =
      WeGoConfig.API_GET_CUSTOMER_BASIC_DETAIL +
      "?customerHashID=" +
      customerHashId;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public UpdateCustomer(customer: CustomerModel): Observable<IAPIResponse> {
    let body = customer;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(WeGoConfig.API_POST_CUSTOMER_DETAIL, body, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public DeleteCustomers(customerHashId: string): Observable<IAPIResponse> {
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });

    return this.http
      .get(
        WeGoConfig.API_POST_DELETE_CUSTOMER +
          "?customerHashID=" +
          customerHashId,
        options
      )
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public ExportCustomerList(input?: DataListModel): any {
    input.currentPage = 0;
    let queryString = this.authService.HandleAPIListInput(input);
    let getUrl = WeGoConfig.API_EXPORT_CUSTOMER_LIST + "?" + queryString;
    let headers = this.authService.GetHeader("text/csv");
    let options = new RequestOptions({ headers: headers });
    return this.http.get(getUrl, options);
  }

  public GetCustomerDropdownList(
    input?: DataListModel
  ): Observable<IAPIResponse> {
    let getCustomerListUrl = WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST;
    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCustomerListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownListCustomer(moduleName: string): Observable<IAPIResponse> {
    let getCustomerUrl: string;
    switch (moduleName) {
      case "Kick_Back_Report":
        getCustomerUrl =
          WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST_FOR_KICK_BACK_REPORT;
        break;
      case "Cost_Center_Report":
        getCustomerUrl =
          WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST_FOR_COST_CENTER_REPORT;
        break;
      default:
        getCustomerUrl = WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST;
        break;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCustomerUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }

  public GetDropdownCustomerListForTemplate(
    permissionType: string,
    customerHashId?: string
  ): Observable<IAPIResponse> {
    let getCustomerListUrl = WeGoConfig.API_GET_DROPDOWN_CUSTOMER_LIST_TEMPLATE;

    if (permissionType) {
      getCustomerListUrl =
        getCustomerListUrl + "?permissionType=" + permissionType;
    }
    if (customerHashId) {
      getCustomerListUrl =
        getCustomerListUrl + "&customerHashId=" + customerHashId;
    }

    let headers = this.authService.GetHeader();
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(getCustomerListUrl, options)
      .map(this.authService.HandleAPIResponse)
      .catch(this.authService.HandleAPIError);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/customer/models/customer.service.ts